export enum ROUTES {
  //utility
  APP_DOWNLOAD = "appDownload",

  // onboarding
  LOGIN = "login",
  SIGNUP = "signup",
  VERIFY_OTP = "verify-otp",
  REGISTER_KYC = "register-kyc",
  EMAIL_MOBILE_VERIFICATION = "email-mobile-verification",
  FORGOT_PASSWORD = "forgot-password",
  UNLOCK_ACCOUNT = "unlock-account",
  CONTACT = "contact",
  INVEST = "invest",
  SWITCH = "switch",
  STP = "stp",
  SWP = "swp",
  REDEEM = "redeem",

  // dashboard
  DASHBOARD = "dashboard",
  PORTFOLIO = "portfolio",
  LUMPSUMSCREEN = "LumpsumScreen",
  TRANSACTIONS = "transactions",
  TRANSACTION_DETAILS = "transaction-details",
  MINOR_PROFILES = "minor-profiles",
  SYSTEMATIC_PLANS = "systematic-plans",
  SYSTEMATIC_PLAN_DETAILS = "systematic-plans/details",
  SYSTEMATIC_PLAN_STATUS = "systematic-plans/status",
  JOINT_PROFILES = "JointHolderProfiles",
  MANDATES = "mandates",
  CREATE_NEW_MANDATE = "create-new-mandate",
  STATEMENTS = "statements",
  FOLIOS = "folios",
  DETAILED_FOLIO = "folio-details",
  FOLIO_PORTFOLIO = "folio-Portfolio",
  PAYMENT_SCREEN = "payment",
  CANCEL_MANDATE_SIP = "cancel-sip",

  //Create New Folio
  CREATE_NEW_FOLIO = "new-folio",
  BANK_DETAILS = "bank-details",
  APPLICANT_DETAILS = "applicant-details",
  NOMINEE_DETAILS = "nominee-details",
  KYC_DETAILS = "kyc-details",
  PAYMENT_DETAILS = "payment-details",
  PAYMENT_STATUS = "payment-status",

  // INvestor Services
  INVESTOR_SERVICES = "investor-services",
  INVESTOR_SERVICES_MODIFY_MOBILE = "investor-services/modify-mobile",
  INVESTOR_SERVICES_MODIFY_EMAIL = "investor-services/modify-email",
  INVESTOR_SERVICES_MODIFY_FATCA = "investor-services/modify-fatca",
  INVESTOR_SERVICES_UPDATE_NOMINEE = "investor-services/update-nominee",
  INVESTOR_SERVICES_UPDATE_BANK = "investor-services/update-bank",
  INVESTOR_SERVICES_UNCLAIMED_REDEMPTION = "investor-services/unclaimed-redemption",
  params = "params",

  // explpore funds and fund details
  EXPLORE_FUNDS = "explore-funds",
  FUND_DETAILS = "fund-details",
}

export enum OTP_TYPE {
  SHARED = "shared",
  SEPARATE = "separate",
}
